import { Span } from 'components/styles_components/container';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'components/ui';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const Confirmation = ({ title, description, onClick, children, disabled }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    !disabled && setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Span onClick={handleClickOpen}>{children}</Span>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <Button variant="text" onClick={handleClose} size="small">
            <FormattedMessage id="button.cancel" />
          </Button>
          <Button
            onClick={() => {
              handleClose();
              onClick();
            }}
            autoFocus
            variant="contained">
            <FormattedMessage id="button.confirm" />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Confirmation;
